import styled from 'styled-components'
import get from 'lodash/get'
import Note from 'components/Note'

const EmailVerifiedSubtitle = styled(Note)`
  font-family: ${props => get(props.theme, 'emailVerifiedPage.subtitle.fontFamily')};
  font-size: ${props => get(props.theme, 'emailVerifiedPage.subtitle.fontSize')};
  color: ${props => get(props.theme, 'emailVerifiedPage.subtitle.color')};
  margin: ${props => get(props.theme, 'emailVerifiedPage.subtitle.margin')};
`

export default EmailVerifiedSubtitle
